import { render, staticRenderFns } from "./AssurancePreferances.vue?vue&type=template&id=69e53416&scoped=true&"
import script from "./AssurancePreferances.vue?vue&type=script&lang=js&"
export * from "./AssurancePreferances.vue?vue&type=script&lang=js&"
import style0 from "./AssurancePreferances.vue?vue&type=style&index=0&id=69e53416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e53416",
  null
  
)

export default component.exports